export const common = {
  site_name: '6080电影网',
  site_slogan: '最新电影抢先看，高清不缓冲免费大片',
  nav_home: '首页',
  nav_category: '分类',
  nav_about: '关于我们',
  nav_new: '最新上映',
  nav_hot: '热门排行',
  hero_title: '最新大片·抢先看',
  hero_subtitle: '高清画质不缓冲，免费无广告，极速秒开',
  hero_cta: '立即观看',
  section_new_movies: '最新上映',
  section_hot_movies: '热门推荐',
  section_top_rated: '口碑排行',
  section_categories: '电影分类',
  view_all: '查看全部',
  movie_rating: '评分',
  movie_views: '次播放',
  movie_director: '导演',
  movie_actors: '主演',
  movie_duration: '片长',
  movie_region: '地区',
  movie_release: '上映日期',
  movie_description: '剧情简介',
  movie_related: '相关推荐',
  breadcrumb_home: '首页',
  footer_description: '6080电影网 - 致力于为广大影迷提供最新、最全的电影在线观看服务。高清画质不缓冲，免费无广告，极速秒开，让您随时随地畅享观影乐趣。',
  footer_quick_links: '快速链接',
  footer_categories: '电影分类',
  footer_contact: '联系我们',
  footer_copyright: '© 2026 6080电影网 版权所有',
  footer_email: 'contact@6080dy.com',
  footer_phone: '400-888-6080',
  about_title: '关于6080电影网',
  about_brand: '品牌介绍',
  about_reputation: '用户口碑',
  about_contact: '联系方式',
  about_faq: '常见问题',
  loading: '加载中...',
  no_data: '暂无数据',
  back_home: '返回首页',
  page_not_found: '页面未找到',
  page_not_found_desc: '您访问的页面不存在，请检查网址或返回首页',
  read_more: '阅读更多',
  play_now: '在线观看',
  category_all: '全部',
  category_action: '动作片',
  category_comedy: '喜剧片',
  category_romance: '爱情片',
  category_scifi: '科幻片',
  category_horror: '恐怖片',
  category_animation: '动画片',
  category_crime: '犯罪片',
  category_war: '战争片',
  category_fantasy: '奇幻片',
};

export default common;